import PlentyApiClient from "./base";

export const sellerlogicApi = {
  getCredentials: () => {
    return PlentyApiClient.get("/sellerlogic/credentials/");
  },

  createCredential: (data) => {
    return PlentyApiClient.post("/sellerlogic/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return PlentyApiClient.delete(`/sellerlogic/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return PlentyApiClient.put(
      `/sellerlogic/credentials/${credentialId}`,
      data,
    );
  },

  toggleActiveCredential: (credentialId) => {
    return PlentyApiClient.post(
      `/sellerlogic/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (credentialId) => {
    return PlentyApiClient.post(
      `/sellerlogic/credentials/${credentialId}/test`,
    );
  },

  testCredentialKey: (data) => {
    return PlentyApiClient.post(`/sellerlogic/credentials/test-key`, data);
  },

  // Fetch Amazon products stock data
  getAmazonProducts: (asins = null) => {
    return PlentyApiClient.post("/sellerlogic/update/products/amazon", {
      asins: asins,
    });
  },

  // Bulk update article prices with marketplace information
  updateArticlePricesBulk: (bulkUpdateRequest) => {
    return PlentyApiClient.post(
      "/sellerlogic/articles/update-prices/bulk",
      bulkUpdateRequest,
    );
  },

  // check last update
  getLastPriceUpdate: () => {
    return PlentyApiClient.get("/sellerlogic/articles/last-update");
  },

  // undo
  revertLastPriceUpdate: () => {
    return PlentyApiClient.post("/sellerlogic/articles/revert-last-update");
  },

  // Update article prices with marketplace information
  updateArticlePrices: (asin, priceUpdates) => {
    return PlentyApiClient.post("/sellerlogic/articles/update-prices", {
      asin: asin,
      price_updates: priceUpdates,
    });
  },

  // Get affected articles based on constraints and adjustments
  getAffectedArticles: (constraintsRequest) => {
    return PlentyApiClient.post(
      "/sellerlogic/fba-articles/affected",
      constraintsRequest,
    );
  },
};
